import React, { ReactNode } from "react";

import UnauthorizedError from "@workflows/support/UnauthorizedError";

import { useFindComponentVisibility } from "@context/authorization/AuthContext";

interface CheckPermissionsProps {
  children: ReactNode;
  name: string;
}

const CheckPermissions = ({ children, name }: CheckPermissionsProps): ReactNode => {
  const isVisible = useFindComponentVisibility(name);

  if (!isVisible) {
    return <UnauthorizedError errorStatus={401} />;
  }

  return children;
};

export default CheckPermissions;
